import React from "react"
import PropTypes from "prop-types"
import Link from "../link"
import * as styles from "./styles.module.scss"

const docType = (format) => {
  let icon
  if (format === "doc") {
    icon = "//addsearch.com/www/script/v3/search-ui-filetype-icon-doc.svg"
  }
  if (format === "pdf") {
    icon = "//addsearch.com/www/script/v3/search-ui-filetype-icon-pdf.svg"
  }
  return icon
}

const title = (item) => {
  return item.title || item.url.split("/").pop() || ""
}

const Result = ({ item }) => (
  <div className={styles.result}>
    <Link to={item.url}>
      {item.images && item.images.main && <img src={item.images.main} alt={item.title} />}
      {item.document_type && item.document_type !== "html" && (
        <div className="file_type">
          <img src={docType(item.document_type)} alt={item.title} />
        </div>
      )}
    </Link>
    <div className="details">
      <h4>
        <Link to={item.url}>{title(item)}</Link>
      </h4>
      <p dangerouslySetInnerHTML={{ __html: item.highlight }} />
    </div>
  </div>
)

const SearchResults = (props) => (
  <div className={styles.modal_results}>
    <h3>Search Results for "{props.label}"</h3>
    <hr />
    <div className={styles.results_list}>
      {props.results.length === 0 ? (
        <div className={styles.no_results}>No results available</div>
      ) : (
        props.results.map((item, i) => <Result item={item} key={`result-${i}`} />)
      )}
    </div>
  </div>
)

Result.propTypes = {
  item: PropTypes.object
}

SearchResults.propTypes = {
  label: PropTypes.string,
  results: PropTypes.array,
  show: PropTypes.bool
}

export default SearchResults
